/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */

import LoadingDialog from '@/controls/Dialog/LoadingDialog';
import UI5ShellBar from '@/controls/UI5ShellBar';
import { useScreenTitle } from '@/hooks/useScreenTitle';
import SessionDialog from '@/controls/Dialog/SessionDialog';
import { Modals } from '@ui5/webcomponents-react';
import { Outlet } from 'react-router-dom';
import { ErrorDisplay } from '@/components/ErrorDisplay/ErrorDisplay';
import { useFeedback } from '@/hooks/useFeedback';
import { InvitationDialog } from '@/controls/InvitationDialog/InvitationDialog';

const AppLayout = () => {
    useScreenTitle();
    useFeedback();

    return (
        <div
            style={{
                height: '100vh',
                display: 'flex',
                flexDirection: 'column',
            }}
            data-testid="app-layout"
        >
            <UI5ShellBar />
            <Modals />
            <Outlet />
            <LoadingDialog />
            <ErrorDisplay />
            <SessionDialog />
            <InvitationDialog />
        </div>
    );
};

export default AppLayout;
